import { type ImageResource } from "@src/images/Images";
import { webSource } from "@src/images/webSource";
import type * as React from "react";

import { StyledImage } from "./ImageStatic.styles";

export type ImageResizeMode = "cover" | "contain" | "fill";

export interface ImageStaticProps {
    height?: number;
    resizeMode?: ImageResizeMode;
    src: ImageResource;
    width?: number;
}

export const ImageStatic: React.FunctionComponent<ImageStaticProps> = ({ src, width, height, resizeMode = "cover", ...restProps }) => {
    const srcStr: string = webSource(src, "1x");
    const srcSet = `${webSource(src, "1x")} 1x, ${webSource(src, "2x")} 2x, ${webSource(src, "3x")} 3x`;

    return <StyledImage src={srcStr} srcSet={srcSet} imageWidth={width} imageHeight={height} resizeMode={resizeMode} {...restProps} />;
};
